import Header from './Header';

function Services() {
    return(
        <div>
            <Header/><br/>
            <div style={{margin:"16px"}}>
            
                <div class="eyebrow">Program & Services</div>
                <p>At <span className="brand">The Turn Around Recovery House</span>, we provide structured, supportive recovery housing designed to promote stability, accountability, and long-term independence.</p>
                <br/>
                <div class="eyebrow">Recovery Housing</div>
                <p>Safe, stable, and structured living environment for individuals committed to recovery.
                <br/><span className="brand">Impact:</span> Increases stability while creating a stronger foundation for long-term success.</p>
                <br/>
                <div class="eyebrow">Peer Support & Accountability</div>
                <p>A supportive community where residents encourage one another and remain accountable.
                <br/><span className="brand">Impact:</span> Reduces isolation and strengthens recovery commitment.</p>
                <br/>
                <div class="eyebrow">Structured Living Program</div>
                <p>House guidelines, routines, and expectations that promote discipline and responsibility.
                <br/><span className="brand">Impact:</span> Builds consistency, structure, and personal accountability.</p>
                <br/>
                <div class="eyebrow">Life Skills Development</div>
                <p>Support with budgeting, employment readiness, and daily living skills.
                <br/><span className="brand">Impact:</span> Improves self-sufficiency and long-term stability.</p>
                <br/>
                <div class="eyebrow">Resource Coordination & Referrals</div>
                <p>Connections to counseling, workforce programs, healthcare, and recovery services.
                <br/><span className="brand">Impact:</span> Expands access to essential support systems.</p>
                <br/>
                <div class="eyebrow">Transition Planning</div>
                <p>Preparation for permanent housing, employment, and independent living.
                <br/><span className="brand">Impact:</span> Supports successful long-term outcomes and stability.</p>
                <br/><br/>
            </div>
        </div>
    )
}
export default Services;